// @ts-check
// ====== F2 UI: Commenti cliente — render nel modal cliente ======
// Iniezione opportunistica: cerca un tab/contenitore '#tabCommenti' o lo crea
// dentro `#modalCliente` accanto agli altri tab. Mostra timeline + form.

const COMMENTI_DEFER_KEY = '__masecommenti';

function findClienteIdByName(name) {
  // @ts-ignore — _clientIdByName globale
  return globalThis._clientIdByName?.get?.(name) || null;
}

function renderCommentiInto(container, clienteId, commenti) {
  // @ts-ignore — getCurrentUser globale
  const me = typeof getCurrentUser === 'function' ? getCurrentUser() : null;
  // @ts-ignore — isAdmin globale
  const admin = typeof isAdmin === 'function' && isAdmin();
  container.innerHTML = `
    <div class="commenti-form">
      <textarea id="commentoNuovoTesto" placeholder="Scrivi un commento, una nota o un aggiornamento di stato cliente…" maxlength="5000"></textarea>
      <div style="display:flex;justify-content:flex-end;gap:8px;">
        <button class="btn btn-primary btn-sm" id="commentoNuovoSalva">Aggiungi commento</button>
      </div>
    </div>
    <div class="commenti-list" id="commentiList">
      ${
        commenti.length
          ? commenti
              .map(
                (c) => `<div class="commento-item" data-cid="${escapeHtml(c.id)}">
        <div class="commento-meta">
          <span><span class="commento-author">${escapeHtml(c.user_name || '—')}</span>
            <span class="muted">· ${escapeHtml(
              // @ts-ignore — fmtDateTime globale
              fmtDateTime(c.created_at)
            )}${c.updated_at !== c.created_at ? ' · modificato' : ''}</span>
          </span>
          <span class="commento-actions">
            ${
              me && (admin || c.user_id === me.id)
                ? `<button data-act="edit">Modifica</button>
               <button data-act="del">Elimina</button>`
                : ''
            }
          </span>
        </div>
        <div class="commento-text">${escapeHtml(c.testo)}</div>
      </div>`
              )
              .join('')
          : '<div class="muted" style="padding:14px;text-align:center;">Nessun commento ancora. Sii il primo a scriverne uno.</div>'
      }
    </div>`;

  container.querySelector('#commentoNuovoSalva').addEventListener('click', async () => {
    const ta = container.querySelector('#commentoNuovoTesto');
    const testo = (ta?.value || '').trim();
    if (!testo) return;
    try {
      // @ts-ignore — commentiApi globale
      await commentiApi.add(clienteId, testo);
      ta.value = '';
      // @ts-ignore
      logAudit?.({
        action: 'create',
        entity: 'Commento',
        target: '',
        details: 'Commento aggiunto'
      });
      // @ts-ignore
      toast('Commento aggiunto');
      reloadCommentiInto(container, clienteId);
    } catch (e) {
      console.error(e);
      // @ts-ignore
      toast('Errore: ' + (e.message || e));
    }
  });

  container.querySelectorAll('.commento-item').forEach((el) => {
    const id = el.dataset.cid;
    el.querySelector('[data-act="edit"]')?.addEventListener('click', async () => {
      const cur = el.querySelector('.commento-text').textContent || '';
      const next = window.prompt('Modifica il commento:', cur);
      if (next == null || next.trim() === cur) return;
      try {
        // @ts-ignore
        await commentiApi.update(id, next);
        // @ts-ignore
        toast('Commento aggiornato');
        reloadCommentiInto(container, clienteId);
      } catch (e) {
        // @ts-ignore
        toast('Errore: ' + (e.message || e));
      }
    });
    el.querySelector('[data-act="del"]')?.addEventListener('click', async () => {
      // @ts-ignore — confirmAction globale
      const ok = await confirmAction({
        level: 'warning',
        title: 'Eliminare commento',
        message: 'Confermi la rimozione del commento?',
        confirmText: 'Elimina'
      });
      if (!ok) return;
      try {
        // @ts-ignore
        await commentiApi.remove(id);
        // @ts-ignore
        toast('Commento eliminato');
        reloadCommentiInto(container, clienteId);
      } catch (e) {
        // @ts-ignore
        toast('Errore: ' + (e.message || e));
      }
    });
  });
}

async function reloadCommentiInto(container, clienteId) {
  try {
    // @ts-ignore
    const list = await commentiApi.list(clienteId);
    renderCommentiInto(container, clienteId, list);
  } catch (e) {
    container.innerHTML = `<div class="muted" style="padding:14px;color:var(--danger);">Errore caricamento commenti: ${escapeHtml((e && e.message) || String(e))}</div>`;
  }
}

/**
 * Inietta il pannello commenti nel modale cliente. Tre strategie:
 *  1) Se esiste già un tab "Commenti" o pannello '#tabCommenti', lo aggiorna.
 *  2) Altrimenti aggiunge un tab dinamico dopo gli altri tab.
 *  3) Fallback: aggiunge un'accordion alla fine del modal-body.
 */
async function injectCommentiPanel() {
  const modal = document.getElementById('modalCliente');
  if (!modal || modal.classList.contains('hidden')) return;
  // @ts-ignore — editingClientName globale
  const nome = globalThis.editingClientName;
  if (!nome) return;
  const clienteId = findClienteIdByName(nome);
  if (!clienteId) return;

  // Cerca/crea il container
  let container = modal.querySelector('#tabCommenti');
  if (!container) {
    // Strategia: append in fondo al modal-body con titolo "Commenti"
    const modalBody = modal.querySelector('.modal-body') || modal.querySelector('form') || modal;
    if (!modalBody) return;
    const block = document.createElement('details');
    block.id = 'tabCommenti';
    block.className = 'stats-block';
    block.open = false;
    block.style.marginTop = '14px';
    block.innerHTML = `<summary style="cursor:pointer;font-weight:600;">Commenti / cronologia note</summary>
      <div id="commentiPanel" style="margin-top:10px;"></div>`;
    modalBody.appendChild(block);
    container = block.querySelector('#commentiPanel');
  }

  // Carica al primo apri o quando il container è già aperto
  await reloadCommentiInto(container, clienteId);
}

// Intercetta `openModal(name, tab)` esistente per iniettare al volo i commenti
const _origOpenModal = globalThis.openModal;
if (typeof _origOpenModal === 'function') {
  globalThis.openModal = function (...args) {
    const r = _origOpenModal.apply(this, args);
    // Wait micro-task per il modal-body finito di renderizzare
    Promise.resolve().then(() => injectCommentiPanel().catch(() => {}));
    return r;
  };
}

// @ts-ignore — global
Object.assign(globalThis, { injectCommentiPanel, reloadCommentiInto, [COMMENTI_DEFER_KEY]: true });
export {};
